import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AlertBuilder } from '../builders/alert.builder';
import { Alert } from '../models/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  private readonly builder = inject(AlertBuilder);

  private readonly showSource$ = new BehaviorSubject<Alert[]>([]);

  public get show$(): Observable<Alert[]> {
    return this.showSource$.asObservable();
  }

  public showSingle(factory: (builder: AlertBuilder) => Alert): void {
    this.showSource$.next([factory(this.builder.newInstance())]);
  }

  public showMultiple(factory: (builder: AlertBuilder) => Alert[]): void {
    this.showSource$.next(factory(this.builder.newInstance()));
  }

  public clear(): void {
    this.showSource$.next([]);
  }
}
